export interface SidebarProgressNavState {
  aiTeacher: boolean
  my: boolean
}

export function getSidebarProgressNavState(pathname: string, search: string): SidebarProgressNavState {
  const isProgress = pathname === '/progress'
  const searchParams = new URLSearchParams(search)
  const aiTeacher = isProgress && searchParams.get('mode') === 'ai-teacher'
  const myWorkspace = pathname === '/me' || pathname.startsWith('/me/')
  const reportFromMy = isProgress && !aiTeacher && searchParams.get('source') === 'me'

  return {
    aiTeacher,
    my: myWorkspace || reportFromMy,
  }
}
